import { getMockMetricsGraph } from 'src/containers/metrics/mockData';
import { scoringInstanceToChart } from 'src/containers/metrics/scoringHealthMock';
import {
  MetricsInterval,
  MetricsTabId,
} from 'src/containers/metrics/constants';
import { MetricsChartData } from 'src/containers/metrics/types';

import { dbTimeseriesToCharts, fetchDbTimeseriesByDatabase } from './dbHealth';
import {
  fetchQueueTimeseriesByIntegration,
  queueTimeseriesToCharts,
} from './queueHealth';
import {
  fetchSageMakerTimeseriesByEndpoint,
  sageMakerTimeseriesToCharts,
} from './sagemakerHealth';
import { fetchScoringTimeseriesByInstance } from './scoringHealth';
import {
  fetchSentryTimeseriesByProject,
  sentryTimeseriesToCharts,
} from './sentryHealth';

/**
 * SageMaker Health uses GET /sagemaker/timeseries/by-endpoint.
 * Queue Health uses GET /queues/timeseries/by-integration.
 * Scoring Health uses GET /scoring/timeseries/by-instance.
 * Database Health uses GET /dbhealth/timeseries/by-database.
 * Sentry Error Tracking uses GET /sentry/timeseries/by-project.
 * Unwired tabs stay on mock data.
 */
export const fetchMetricsHealth = async (
  tabId: MetricsTabId,
  interval: MetricsInterval
): Promise<MetricsChartData[]> => {
  if (tabId === 'sagemaker') {
    const response = await fetchSageMakerTimeseriesByEndpoint(interval);
    return sageMakerTimeseriesToCharts(response, interval);
  }

  if (tabId === 'database') {
    const response = await fetchDbTimeseriesByDatabase(interval);
    return dbTimeseriesToCharts(response, interval);
  }

  if (tabId === 'queue') {
    const response = await fetchQueueTimeseriesByIntegration(interval);
    return queueTimeseriesToCharts(response, interval);
  }

  if (tabId === 'scoring') {
    const response = await fetchScoringTimeseriesByInstance(interval);
    return response.instances.map((instance) =>
      scoringInstanceToChart(
        instance,
        response.timestamps,
        interval,
        response.stepSeconds
      )
    );
  }

  if (tabId === 'sentry') {
    const response = await fetchSentryTimeseriesByProject(interval);
    return sentryTimeseriesToCharts(response, interval);
  }

  return [getMockMetricsGraph(tabId, interval)];
};
